module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"Example":"Пример","Optimal Balance":"оптимальная сумма","Deficit":"недостаток","Surplus":"излишек","in Reserves":"в Резервах","Now in Reserves":"Сейчас в Резервах","Tomorrow":"Завтра","The day after tomorrow":"Послезавтра","Two days after tomorrow":"После-послезавтра"}}')
  delete Component.options._Ctor
}
